import {DriverInsuranceTypeEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function driverInsuranceTypeNameFilter(type: DriverInsuranceTypeEnum): string {
  switch (type) {
    case DriverInsuranceTypeEnum.InsuranceFromWork: return i18n.t(LF.InsuranceFromWork) as string;
    case DriverInsuranceTypeEnum.InsuranceFromDuty: return i18n.t(LF.InsuranceFromDuty) as string;
    case DriverInsuranceTypeEnum.InsuranceFromOtherOrder: return i18n.t(LF.InsuranceFromOtherOrder) as string;
    case DriverInsuranceTypeEnum.InsuranceFromContract: return i18n.t(LF.InsuranceFromContract) as string;
    case DriverInsuranceTypeEnum.InsuranceFromDifferentSource: return i18n.t(LF.InsuredFromDifferentSource) as string;
    case DriverInsuranceTypeEnum.Pensioner: return i18n.t(LF.Pensioner) as string;
    case DriverInsuranceTypeEnum.Annuitant: return i18n.t(LF.Annuitant) as string;
    case DriverInsuranceTypeEnum.Student: return i18n.t(LF.Student) as string;
    case DriverInsuranceTypeEnum.DisabilityCertificate: return i18n.t(LF.DisabilityCertificate) as string;
  }
}
